import type { FC } from "react"
import { forwardRef } from "react"
import Typography from "@mui/material/Typography"
import Box from "@mui/material/Box"

interface PageTitleProps {
  text: string
  styles?: object
  variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
}

const PageTitle: FC<PageTitleProps> = ({ text, styles, variant }) => {
  return (
    <Box sx={{ ...styles }}>
      <Typography variant={variant || "h3"} component="h3">
        {text}
      </Typography>
    </Box>
  )
}

export const TitleWithRef = forwardRef<HTMLDivElement, PageTitleProps>(
  function TitleWithRef(props, ref) {
    return (
      <div ref={ref} style={{ height: "fit-content" }}>
        <PageTitle {...props} styles={{ pb: 0 }} />
      </div>
    )
  },
)

export default PageTitle
